<form class="tenant-custom-form" [formGroup]="fieldsArray" *ngIf="formConfig" (ngSubmit)="submit()">
    <h1 class="tenant-custom-form-title">
        Documentación para su garantía
    </h1>
    <span class="tenant-custom-form-description">
        {{ formConfig.mensaje }}
    </span>
    <ng-container *ngFor="let field of formConfig.campos; let i = index">
        <mat-form-field class="garantor-form-field complete-documentation" appearance="outline" *ngIf="field.tipo === 'INPUT'">
            <mat-label>{{ field.nombre }}</mat-label>
            <input matInput [formControl]="fieldsArray.controls[i]">
            <mat-error *ngIf="fieldsArray.controls[i].hasError('required')">
                Por favor complete este campo
            </mat-error>
            <mat-hint *ngIf="field.descripcion">{{ field.descripcion }}</mat-hint>
        </mat-form-field>
        <app-file-uploader
            [formControl]="fieldsArray.controls[i]"
            [label]="field.nombre"
            [hint]="field.descripcion"
            requiredErrorMessage="Por favor seleccione un archivo"
            *ngIf="field.tipo === 'UPLOAD'"
        ></app-file-uploader>
    </ng-container>
    <div class="buttons">
        <button mat-raised-button color="accent" class="garantor-button" type="button" (click)="cancelForm()">No tengo la documentación</button>
        <button mat-raised-button color="primary" class="garantor-button send-documentation">Enviar</button>
    </div>
</form>
